var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCashfree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 1024 512",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.091 0C407.188 0 369.469 38.0474 369.469 84.6227H684.016C730.919 84.6227 768.639 46.5753 768.639 0H454.091Z",
    fill: "#04AB61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.469 84.6227C369.469 37.7194 407.516 0 454.091 0V314.547C454.091 361.451 416.044 399.17 369.469 399.17V84.6227Z",
    fill: "#04AB61"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M480.988 112.83V197.453H579.715C626.618 197.453 664.338 159.405 664.338 112.83H480.988Z",
    fill: "#FBB016",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 197.453C255 150.55 293.047 112.83 339.623 112.83V427.377C339.623 474.281 301.575 512 255 512V197.453Z",
    fill: "#FBB016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_43"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 512,
    width: 1024
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCashfree);
export default __webpack_public_path__ + "static/media/ic_cashfree.906f7eac8c00cfc7d4db63a6dcfb656e.svg";
export { ForwardRef as ReactComponent };